export default {
    getLatestCourse: {
        url: '/crm/crmpublish/getLatestPublish',
        method: 'get'
    },
    getPublishCourseDetail: {
        url: '/crm/crmpublish/detail',
        method: 'get'
    },
    getPublishCourseLessonDetail: {
        url: '/crm/crmpublish/getPublishLessonDetailList',
        method: 'get'
    },
    getPublishCategory: {
        url: '/crm/publishcategory/getAllCategory',
        method: 'get'
    },
    getPublishList: {
        url: '/crm/crmpublish/list',
        method: 'get'
    },
    saveCourseView: {
        url: '/crm/courseview/addCourseView',
        method: 'get'
    },
    sendPage: {
        url: '/crm/studentsignup/sendPage',
        method: 'get'
    },
    getCourseRecommend: {
        url: '/crm/crmpublishrecommend/getRecommendList',
        method: 'get'
    },
    isStart: {
        url: '/crm/crmpublish/isStart',
        method: 'get'
    },
    isEnd: {
        url: '/crm/crmpublish/isEnd',
        method: 'get'
    },
    isReservationCourse: {
        url: '/crm/studentsignup/isReservationCourse',
        method: 'get'
    },
    courseApplyAnalysis: {
        url: '/crm/studentsignup/courseApplyAnalysis',
        method: 'get'
    },
    courseApplyList: {
        url: '/crm/studentsignup/courseApplyList',
        method: 'get'
    },
}
